import auth from './modules/auth/auth'
import users from './modules/admin/users'
import boards from './modules/admin/boards'
import clients from './modules/clients/clients'
import contactsClient from './modules/clients/contactsClient'
import tickets from './modules/registers/tickets'
import contacts from './modules/contacts/contacts'
import periods from './modules/periods/periods'
import reports from './modules/reports/reports'
import billings from './modules/billings/billings'
import sendEmail from './modules/sendEmail/sendEmail'
import franchiseNotifications from './modules/notifications/franchiseNotifications'

export default {
  auth,
  users,
  boards,
  clients,
  contactsClient,
  tickets,
  contacts,
  periods,
  reports,
  billings,
  sendEmail,
  franchiseNotifications,
}
